import { Chip, Link, Stack, styled, Typography } from "@mui/material";
import * as React from "react";

interface ActivityUpdateProps {
  text: string;
  label?: string;
  labelSecondary?: string;
  link?: string;
  icon?: React.ReactNode;
  variant?: "success" | "warning" | "error" | "info" | "primary" | "default";
}
export const ActivityUpdate: React.FC<ActivityUpdateProps> = (props) => {
  const { text, label, labelSecondary, link, icon, variant } = props;
  return (
    <Row direction="row" alignItems="center" justifyContent="space-between" variant={variant}>
      {link ? (
        <Link underline="hover" color="primary.text" href={link} target="_blank">
          {text}
        </Link>
      ) : (
        <Typography>
          {icon && icon}
          {text}
          {labelSecondary && (
            <Chip
              label={labelSecondary}
              component="span"
              variant="outlined"
              color="primary"
              size="micro"
              sx={{ ml: 0.5, verticalAlign: "baseline" }}
            />
          )}
        </Typography>
      )}

      {label && <Chip label={label} color={variant} size="micro" />}
    </Row>
  );
};

const Row = styled(Stack, { shouldForwardProp: (prop) => prop !== "variant" })<{
  variant?: string;
}>(({ theme, variant }) => ({
  backgroundColor: theme.palette.backgroundAlpha.main,
  border: "1px solid rgba(255, 255, 255, 0.05)",
  borderRadius: "6px",
  padding: 8,
  ...(variant === "warning" && {
    backgroundColor: theme.palette.warning.alpha,
    color: theme.palette.warning.main,
  }),
  svg: {
    width: "16px",
    height: "16px",
    marginRight: "8px",
    verticalAlign: "bottom",
  },
}));

export default ActivityUpdate;
